"use client";

import { useLocalViewStep } from "./local-view-context";

export function OnboardingSteps({ labels, current, completed = [], onSelect }: { labels: readonly string[]; current: number; completed?: readonly number[]; onSelect?: (index: number) => void }) {
  const viewStep = useLocalViewStep();
  // Free viewing opens isolated preview panels instead of navigating real state.
  const select = viewStep ?? onSelect;
  // Preserve panel indices while opening the completion result directly.
  const creator = labels === creatorSteps;
  const stages = creator
    ? [{ label: "注册账号", panels: [0] }, { label: "活体认证", panels: [1, 2] }, { label: "入驻协议", panels: [3] }, { label: "完成入驻", panels: [4, 5] }]
    : labels === agentSteps ? [{ label: "注册账号", panels: [0, 1] }, { label: "企业认证", panels: [2] }, { label: "联系我们", panels: [3] }, { label: "完成入驻", panels: [4, 5] }]
    : [{ label: labels[0], panels: [0] }, { label: "注册账号", panels: [1] }, { label: "企业认证", panels: [2] }, { label: labels[3], panels: [3] }, { label: "完成入驻", panels: [4, 5] }];
  return <>
    <ol aria-label="入驻进度" className="rg-stage-progress">
      {stages.map(({ label, panels }, index) => {
        const active = panels.includes(current);
        const done = panels.every(panel => completed.includes(panel));
        // Keep the visual rail continuous when preview navigation skips panels.
        // Actual completion still controls which panel is opened on selection.
        const reached = panels[panels.length - 1] < current;
        const target = done || panels.includes(5) ? panels[panels.length - 1] : panels[0];
        const canSelect = Boolean(viewStep) || target <= current;
        return <li key={label} aria-current={active ? "step" : undefined} className={active ? "is-current" : done ? "is-done" : reached ? "is-reached" : ""}>
          {select ? <button type="button" disabled={!canSelect} onClick={() => { if (canSelect) select(target); }} aria-label={`查看${label}`}>{label}</button> : <span>{label}</span>}
          <span className="sr-only">第 {index + 1} 阶段，共 {stages.length} 阶段</span>
        </li>;
      })}
    </ol>
  </>;
}
export const creatorSteps = ["注册账号", "实名认证", "人脸识别", "协议与敏感信息", "确认入驻", "完成入驻"];
export const merchantSteps = ["厂商类型", "注册账号", "企业认证", "入驻协议", "确认入驻", "完成入驻"];

export const agentSteps = ["注册账号", "注册账号", "企业认证", "联系我们", "确认入驻", "完成入驻"];
